export class PagerBase {
  pageSizes = [25, 50, 100, 200];
  defaultPageSize = 25;

  modalPageSizes = [10, 20, 50];
  defaultModalPageSize = 10;
}
